import { render, staticRenderFns } from "./iconSave.vue?vue&type=template&id=7c3193b0&"
import script from "./iconSave.vue?vue&type=script&lang=js&"
export * from "./iconSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports